import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { DEFAULT_MAX_RETRIES } from './config';
let $logger;
const DEFAULTENTRYTYPES = ['measure', 'navigation', 'resource'];

const getBaseMetricDimensions = entry => {
  const dims = {};
  const entryJson = entry.toJSON(); // eslint-disable-next-line no-restricted-syntax

  for (const prop in entryJson) {
    if (['string', 'number'].includes((typeof entryJson[prop]).toLowerCase())) {
      dims[prop] = entryJson[prop];
    }
  }

  return dims;
};

const getMetricDimensionsForMeasure = entry => getBaseMetricDimensions(entry);

const getMetricDimensionsForNavigation = entry => {
  let dimensions = getBaseMetricDimensions(entry);
  const loadTime = entry.loadEventEnd - entry.startTime;
  const domContentLoadTime = entry.domContentLoadedEventEnd - entry.domContentLoadedEventStart;
  const domCompleteTime = entry.domComplete - entry.domContentLoadedEventStart;
  dimensions = _objectSpread(_objectSpread({}, dimensions), {}, {
    loadTime,
    domContentLoadTime,
    domCompleteTime
  });
  return dimensions;
};

const getMetricDimensionsForResource = entry => {
  let dimensions = getBaseMetricDimensions(entry);
  const requestDuration = entry.responseEnd - entry.requestStart;
  const responseDuration = entry.responseEnd - entry.responseStart;
  dimensions = _objectSpread(_objectSpread({}, dimensions), {}, {
    requestDuration,
    responseDuration,
    duration: entry.duration
  });
  return dimensions;
};

const logPerformance = entry => {
  let dimensions = {};
  const metricNamespace = 'Performance';
  const metricEventName = entry.entryType;
  const metricValue = 1;
  const metricType = 'counter';
  let entryMeasure;
  let entryNavigation;
  let entryResource;
  let entryName = 'Unknown performance entry name';

  switch (entry.entryType) {
    case 'measure':
      entryMeasure = entry;
      dimensions = getMetricDimensionsForMeasure(entryMeasure);
      break;

    case 'navigation':
      entryNavigation = entry;
      dimensions = getMetricDimensionsForNavigation(entryNavigation);
      entryName = entryNavigation.name;
      break;

    case 'resource':
      entryResource = entry;
      dimensions = getMetricDimensionsForResource(entryResource);
      entryName = entryResource.name;
      break;

    default:
      console.log(`Unconfigured performance entry found for ${entry.entryType}:${entry.name}`);
      break;
  }

  const metricPayload = {
    name: entryName,
    metricNamespace,
    metricEventName,
    metricValue,
    metricType,
    dimensions
  };
  $logger.metric(metricPayload);
};

const perfObserver = (entries, observer) => {
  entries.getEntries().forEach(entry => {
    if (!( // Do not log beacons - this is how the logger sends log messages to the log service
    entry.entryType.toLowerCase() === 'resource' && entry.initiatorType.toLowerCase() === 'beacon')) {// console.log(`navigation: ${JSON.stringify(entry)}`);
      // logPerformance(entry);
    }
  });
};
/**
 * Fetch Retries...
 */


const MAXRETRIES = DEFAULT_MAX_RETRIES || 0;
const INITIALBACKOFFTIME = 500; // .5 SECONDS

const {
  fetch: originalFetch
} = window;

const wait = delay => new Promise(resolve => setTimeout(resolve, delay));

const getResource = input => {
  let resource = ''; // input can be either a string, a Request, or a URL...

  if (typeof input === 'string') {
    // input is a string
    resource = input;
  } else if (typeof input === 'object') {
    if ('url' in input) {
      // Request objects have a 'url' property, but URL objects don't
      resource = input.url;
    }
  }

  return resource;
};

const fetchRetry = async (input, fetchOptions, delay, tries) => {
  const resource = getResource(input);

  const onError = error => {
    if (tries >= MAXRETRIES) {
      $logger.error('Fetch Error', {
        events: [{
          level: 'error',
          resource,
          name: error.name,
          message: error.message,
          stack: error.stack
        }]
      });
      throw error;
    }

    $logger.warn(`Retrying (${tries}/${MAXRETRIES}) fetch to ${resource}`, {
      events: [{
        level: 'warn',
        resource,
        name: 'retry',
        attempt: `${tries}/${MAXRETRIES}`
      }]
    });
    return fetchRetry(input, fetchOptions, delay, tries + 1); // Incremental backoff - this is commented out pending further work to verify proper functionality
    // return wait(delay).then(() =>
    //   fetchRetry(input, fetchOptions, delay, tries + 1),
    // );
  };

  $logger.debug(`Fetch attempt (${tries}/${MAXRETRIES}) to ${resource}`);
  return originalFetch(input, fetchOptions).catch(onError);
};

const replaceFetch = () => {
  window.fetch = (input, init) => fetchRetry(input, init, INITIALBACKOFFTIME, 0);
};

const startListeners = parms => {
  const {
    entryTypes
  } = parms;
  const observer = new PerformanceObserver(perfObserver);
  const observerOptions = {};
  observerOptions.entryTypes = entryTypes || DEFAULTENTRYTYPES;
  observer.observe(observerOptions);
};

export const initializeLoggerListeners = parms => {
  const {
    logger,
    entryTypes
  } = parms;

  if (!logger) {
    throw new Error('Error - Unable to initialize logger listeners; No logger provided.');
  }

  $logger = logger;
  replaceFetch();
  startListeners({
    entryTypes
  });
};